import React, { PropTypes } from "react";

import { BlocClientsDataTable } from "./";

const BlocClientsPage = (props) => {
  return <BlocClientsDataTable blocId={props.params.blocId} />;
};

BlocClientsPage.propTypes = {
  children: PropTypes.node,
  params: PropTypes.shape({
    blocId: PropTypes.string,
  }),
};

export default BlocClientsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/clients/BlocClientsPage.js